import React from 'react';
import { NumberedListProps } from './types';
import SerializeDescription from '../serialize-description/SerializeDescription';

export const NumberedList: React.FC<NumberedListProps> = ({
  numberedListRow,
  title,
  spacingTop,
  spacingBottom,
  sectionBackgroundColor,
  sectionId,
}) => (
  <div
    id={sectionId}
    className={`numbered-list mx-4 md:mx-auto md:w-full bg-${sectionBackgroundColor} ${
      spacingTop && spacingBottom
        ? 'py-4 md:py-8 lg:py-20'
        : spacingTop
          ? 'pt-4 md:pt-8 lg:pt-20'
          : spacingBottom
            ? 'pb-4 md:pb-8 lg:pb-20'
            : ''
    }`}
  >
    <div className="md: mx-auto md:container">
      <h2
        className={`mb-16 text-center text-4xl font-bold ${
          sectionBackgroundColor === 'brand-700'
            ? 'text-white'
            : 'text-brand-700'
        }`}
      >
        {title}
      </h2>

      {numberedListRow.map((group, index) => (
        <div
          key={group.id}
          className="numbered-list-group container mx-auto mb-6 flex flex-col items-center gap-2 border-b pb-6 md:flex-row md:items-start md:gap-4"
        >
          <div
            className={`bg-${sectionBackgroundColor} container relative z-10 mx-auto hidden`}
          >
            Test
          </div>
          <section className="flex w-full flex-col justify-center gap-1 md:flex-row md:gap-11">
            <div className="number-container">
              <section
                className={`number flex h-[42px] w-[42px] items-center justify-center rounded-full border-2 text-lg font-medium ${
                  sectionBackgroundColor === 'brand-700'
                    ? 'border-white text-white'
                    : 'border-brand-700 text-brand-700'
                }`}
              >
                {index + 1}
              </section>
            </div>
            <h3
              className={`numbered-list-group-title w-full text-2xl font-medium md:mb-4 ${
                sectionBackgroundColor === 'brand-700'
                  ? 'text-white'
                  : 'text-brand-700'
              }`}
            >
              {group.title}
            </h3>
          </section>

          <div className="flex w-full justify-between">
            <ul className="list-disc pl-8">
              {group.numberedListRow.map((row) => (
                <li
                  key={row.id}
                  className={`mb-2 text-lg ${sectionBackgroundColor === 'brand-700' ? 'text-white' : 'text-neutral-800'}`}
                >
                  {row.bulletField && (
                    <SerializeDescription description={row.bulletField} />
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
);
